import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/streams')({
  component: () => <PageStub title="Streams" description="Workflow streams and automation" />,
});
